var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<a ng-click=\"$ctrl.ibox.toggle()\" ng-if=\"::!$ctrl.ibox.cantToggle\"><i class=\"m-l-1 fa fa-lg fa-chevron-{{$ctrl.ibox.collapsed?'down':'up'}}\"></i></a>";
var id1="ibox.toolbar.toggle.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;